import { type FC, type ReactNode } from "react";

import { AppContext, type AppContextData } from "@/shared/hooks/useAppContext";
import { DEMO_MOCK_USER } from "@/pages/demo/data/mockData";

export const DemoAppContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const mockValue: AppContextData = {
    authUser: null,
    user: DEMO_MOCK_USER,
    person: null,
    isLoading: false,
    error: null,
    refetch: () => {},
  };

  return <AppContext.Provider value={mockValue}>{children}</AppContext.Provider>;
};
